<!-- ProFeatureChip.vue - Small chip indicator to be placed next to existing button -->
<template>
    <div class="pro-feature-chip" :class="{ 'is-active': isActive }">
      PRO
    </div>
  </template>

  <script>
  export default {
    name: 'ProFeatureChip',
    props: {
      isActive: {
        type: Boolean,
        default: false
      }
    }
  }
  </script>

  <style scoped>
  .pro-feature-chip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: bold;
    padding: 2px 6px;
    border-radius: 4px;
    margin-left: 6px;
    background-color: #e5e7eb;
    color: #4b5563;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    user-select: none;
    transition: all 0.2s ease;
  }

  .pro-feature-chip.is-active {
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    color: white;
    box-shadow: 0 1px 3px rgba(139, 92, 246, 0.3);
  }
  </style>
